/**
 * Recoverable full-screen fallback shown when the app cannot load a page chunk
 * and the automatic reload budget is spent (see `vite-preload-recovery`). Shared
 * by the render-time `RootErrorBoundary` and the initial-load `resolve` catch in
 * `app.tsx` so both failure paths land on the same friendly screen instead of a
 * blank white page.
 */
export function StaleChunkFallback() {
  return (
    <div className="bg-background text-foreground flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <div className="space-y-1">
        <h1 className="text-lg font-semibold">Se perdió la conexión</h1>
        <p className="text-muted-foreground max-w-sm text-sm">
          No pudimos cargar esta pantalla. Suele ser temporal — recarga para volver a intentarlo.
        </p>
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex h-9 items-center justify-center rounded-md px-4 text-sm font-medium transition-colors"
      >
        Recargar
      </button>
    </div>
  );
}
